import React from 'react'
import { Avatar } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';

interface Props {
  avatarURL: string
}

export function ProfileAvatar(props: Props) {
  return (
    <Link to={'/profile'}>
      <Avatar
        size={'large'}
        icon={
          props.avatarURL
            ? <img src={props.avatarURL} alt='Avatar' />
            : <UserOutlined />
        }
        style={{ margin: 15 }} />
    </Link>
  );
}